module.exports = __webpack_public_path__ + "assets/img/prt9.4ccbce59.png";